import React from "react";

const Footer = () => {
    return <footer>
        <p>©2023 React Do It! - desarrollado por Rodrigo Vergara <a href="https://rodrigovergara.com.ar/" target="_blank" rel="noreferrer">portafolio aquí</a></p>
    </footer>
}

export default Footer;